<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <app-base-main parentTable>
        <template #filter-group>
            <app-filter-group
                    @query="$gjNoticeQuery"
                    @reset="$gjReset">

                <gj-warehouse-select
                        v-model="filter.warehouseIds"
                        multiple
                        width="190px"
                ></gj-warehouse-select>

                <gj-select-input
                        v-model="filter.keyword"
                        :options="[
                       {id: 'msku', text: 'MSKU'},
                       {id: 'fnsku', text: 'FNSKU'}
                   ]"
                        :width="['90px', '140px']"
                >
                </gj-select-input>
                <gj-select
                        placeholder="原因"
                        collapse-tags
                        v-model="filter.reasonType"
                        :width="'120px'"
                        :options="[
                            {id: 'DAMAGED', text: '已残损'},
                            {id: 'DISCARD_INVENTORY', text: '弃置库存'},
                            {id: 'FOUND', text: '已找到'},
                            {id: 'LOST', text: '丢失'},
                            {id: 'OTHER', text: '其它'}
                        ]"
                />
                <gj-select
                        v-model="filter.disposition"
                        placeholder="描述"
                        collapse-tags
                        :width="'150px'"
                        :options="[
                            {id: 'SELLABLE', text: '可售'},
                            {id: 'DEFECTIVE', text: '存在瑕疵'},
                            {id: 'CUSTOMER_DAMAGED', text: '因买家导致的残损'},
                            {id: 'DISTRIBUTOR_DAMAGED', text: '因分销商导致的残损'},
                            {id: 'WAREHOUSE_DAMAGED', text: '在库房出现残损'},
                            {id: 'CARRIER_DAMAGED', text: '因承运人导致的残损'},
                            {id: 'EXPIRED', text: '已过期'}
                        ]"
                />

                <gj-select-date-picker
                        v-model="filter.date"
                        type="daterange"
                        :options="[
                            {id: 'marketTime', text: '盘点时间(站点时区)'},
                            {id: 'zeroZoneTime', text: '盘点时间(零时区)'}
                        ]"
                        :width="['150px']"
                >
                </gj-select-date-picker>

                <template #right>
                    <gj-tool-group
                            help
                            setting :table-name="tableName"
                            :table-columns="columns"
                            :sort-gjtable="$refs.gjTable"
                            :download="$permission('inventoryAdjustments:export')"
                            download-url="/operation/inventoryAdjustments/export"
                            :download-params="globalParams"
                    >
                    </gj-tool-group>
                    <view-setting
                            :ref="REF_VIEW_SETTING"
                            save-mode="remote"
                            :use-default="true"
                            :module-name="moduleName"
                            :config="model"
                            :fn-generate-params="generateViewParams"
                            @view-change="handleChangeView"
                            @view-complete="handCompleteView"
                    >
                    </view-setting>
                </template>
            </app-filter-group>
        </template>
        <template #table>
            <gj-table
                    ref="gjTable"
                    adaptParent
                    :name="tableName"
                    :data="tableData"
                    :columns="columns"
                    :loading="loading"
                    sortable="custom"
                    show-summary
                    :default-sort="{prop: 'impressions', order: 'descending'}"
                    :size="'has-picture'"
                    :pagination="pagination"
                    @sort-change="$gjSortChange"
                    @page-change="$gjNoticeQuery">
                <template v-slot:productName="{row}">
                    <div>
                        <div class="text-ellipsis-1">{{row.productName}}</div>
                    </div>
                </template>
            </gj-table>
        </template>
    </app-base-main>

</template>

<script>
    import {queryMixin} from "../../../../minxins";
    import {
        exportInventoryAdjustments,
        getInventoryAdjustmentsPage
    } from "../../../../api/statistics";
    import {isMeaningful} from "../../../../utils/common";
    import {convertToDate, generateViewParams} from "../../../../utils/date.util";
    import viewConfig from './viewConfig'

    export default {
        name: "app-inventoryAdjustments",
        mixins: [queryMixin],
        components: {
        },
        data() {
            return {
                tableName: 'inventoryAdjustments',
                columns: [
                    // id: 字段ID，用于优化渲染以及自定义列，必填
                    // header: 表头名称结构为：slot:slotName:name（slot: 是否插槽，slotName: 引用的插槽名，name：表头名称，用于自定义列的表头名）
                    // field: 字段内容域，类型为数据字段名或slot
                    // help: 帮助信息（问号）
                    // notCustomColumn: 是否是自定义字段，默认：false
                    // default: 是否自定义列默认字段
                    // {marketName: 'aa', asin: 'asin1'}
                    {id: 'warehouseName', header: '仓库', field: 'warehouseName', minWidth: '130px', sortable: true, sortBy: 'warehouseId', default: true, disabled: true, fixed: 'left'},
                    {id: 'transactionItemId', header: '交易商品编号', field: 'transactionItemId', minWidth: '110px', default: true, fixed: 'left'},
                    {id: 'msku', header: 'MSKU', field: 'msku', sortable: true, minWidth: '140px', default: true, fixed: 'left'},
                    {id: 'fnsku', header: 'FNSKU', field: 'fnsku', sortable: true, minWidth: '130px', default: true, fixed: 'left'},
                    {id: 'productName', header: '标题', field: 'slot:productName', minWidth: '110px', default: true},
                    {id: 'fulfillmentCenterId', header: '亚马逊仓库代码', field: 'fulfillmentCenterId', minWidth: '120px', default: true},
                    {id: 'quantity', header: '数量', field: 'quantity', sortable: true, minWidth: '90px', align: 'right', default: true, summary: true},
                    {id: 'reason', header: '原因代码', field: 'reason', minWidth: '90px', default: true},
                    {id: 'reasonName', header: '原因', field: 'reasonName', minWidth: '90px', default: true},
                    {id: 'dispositionName', header: '描述', field: 'dispositionName', sortable: true, minWidth: '130px', default: true},
                    {id: 'reconciled', header: '协调数量', field: 'reconciled', sortable: true, minWidth: '90px', align: 'right', default: true, summary: true},
                    {id: 'unreconciled', header: '未协调数量', field: 'unreconciled', sortable: true, minWidth: '100px', align: 'right', default: true, summary: true},
                    {id: 'marketTime', header: '盘点日期(市场时区)', field: 'marketTime', sortable: true, minWidth: '155px', default: true},
                    {id: 'zeroZoneTime', header: '盘点日期(零时区)', field: 'zeroZoneTime', sortable: true, minWidth: '155px', default: true},
                    {id: 'updateTime', header: '更新时间', field: 'updateTime', sortable: true, minWidth: '160px', default: true}
                ],
                tableData: [],
                filter: {
                    warehouseIds: null,
                    reasonType: null,
                    disposition: null,
                    keyword: {
                        key: 'msku', value: null,
                    },
                    date: {
                        key: 'marketTime', value: null,
                    },
                },
                keyword: {
                    key: 'msku',
                    value: null
                },
                modalVisible: {
                    logModal: false,
                    detailModal: false,
                    clickDownload: false,
                },
                model: viewConfig,
                moduleName: 'INVENTORY_ADJUSTMENTS'
            }
        },
        created() {
            this.sort.prop = null;
        },
        methods: {
            generateViewParams,
            /**
             * 设置全局查询参数
             */
            mergeRemoteParams (params) {
                const date = params.date ? params.date : { key: params.dateType, value: [params.startDateTime, params.endDateTime]}
                this.filter = Object.assign({}, this.filter, {
                    ...params,
                    date
                })
            },
            $gjQueryInitParams() {
                return {
                    filter: {
                        warehouseIds: null,
                        reasonType: null,
                        disposition: null,
                        keyword: {
                            key: 'msku', value: null,
                        },
                        date: {
                            key: 'marketTime', value: null,
                        },
                    }
                };
            },
            $gjQuery() {
                // 构造查询参数
                const params = {
                    model: {
                        warehouseIds: this.filter.warehouseIds,
                        reasonType: this.filter.reasonType,
                        disposition: this.filter.disposition,
                    },
                    ...this.queryPagination,
                    ...this.querySort
                };
                params.model[this.filter.keyword.key] = this.filter.keyword.value;
                // 时间
                if (isMeaningful(this.filter.date.value)) {
                    if (this.filter.date.key === 'marketTime') {
                        params.model.startMarketTime = convertToDate(this.filter.date.value[0]);
                        params.model.endMarketTime = convertToDate(this.filter.date.value[1]);
                    } else if (this.filter.date.key === 'zeroZoneTime') {
                        params.model.startZeroZoneTime = convertToDate(this.filter.date.value[0]);
                        params.model.endZeroZoneTime = convertToDate(this.filter.date.value[1]);
                    }
                }
                this.globalParams = params;
                // 查询
                this.loading = true;
                getInventoryAdjustmentsPage(params)
                    .then((data) => {
                        if (isMeaningful(data)) {
                            this.tableData = data.records;

                            this.pagination = this.getPagination(data);
                        }
                    })
                    .complete(() => {
                        this.loading = false;
                    })
            },
            download() {
                exportInventoryAdjustments(this.globalParams);
            },
        },
    }
</script>

<style scoped>

</style>
